
import * as yup from 'yup';

// ✅ Yup validation schema
const blogSchema = yup.object().shape({
    title: yup.string().required('Title is required'),
    cover_image: yup.string().nullable(),
    text_editor: yup
        .string()
        .nullable(),
    publisher: yup.string().nullable(),
    blog_desktop_banner: yup.string().nullable(),
    blog_mobile_banner: yup.string().nullable(),
    categoryId: yup.string().required('Category is required'),
    cover_video: yup.string().nullable().notRequired(),
    redirectional_url: yup.string().url('Invalid URL format').required('URL is required'),
    blog_for: yup.string().nullable().notRequired(),
});


const categorySchema = yup.object().shape({
    title: yup
        .string()
        .required('Category title is required')
        .max(100, 'Title must be at most 100 characters'),

    description: yup
        .string()
        .max(1000, 'Description must be at most 1000 characters')
        .required('Description is required'),
});

export { blogSchema, categorySchema };